import React, { FC } from 'react';
import { Grid, Switch, Typography } from '@material-ui/core';
import { useField } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

import { Network } from 'api';
import { SocialIcon } from 'components';
import { ShareCopyProvider } from 'providers';

import { ShareItem } from '../types';
import ShareCopy from './ShareCopy';

interface Props {
  index: number;
}

const useStyles = makeStyles(theme => ({
  title: {
    marginTop: theme.spacing(0.5),
  },
}));

const LinkedInPage: FC<Props> = ({ index }) => {
  const classes = useStyles();
  const [field] = useField<ShareItem>(`items.${index}`);

  const { name, value, onChange } = field;
  const { active, socialAccount } = value.state;

  return (
    <ShareCopyProvider network={Network.Linkedin}>
      <Grid container alignItems="baseline" justify="space-between">
        <Grid item>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <SocialIcon
                size={24}
                state={active ? 'active' : 'disabled'}
                provider={socialAccount.provider}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2" className={classes.title}>
                {socialAccount.profile_name}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Switch name={`${name}.state.active`} checked={active} onChange={onChange} />
        </Grid>
      </Grid>
      {active && <ShareCopy index={index} />}
    </ShareCopyProvider>
  );
};

export default LinkedInPage;
